import * as React from 'react';
import { translate } from 'react-i18next';
const { connect } = require('react-redux');
import { browserHistory } from 'react-router';
import { Field, reduxForm, InjectedFormProps, getFormSyncErrors } from 'redux-form';
import { IStore } from 'redux/IStore';
import { getUserPreferences, putUserPreferences } from 'modules/user/userpreferences';
import { IUserPreferences, IUserPreferencesAction } from 'models/user/userpreferences';
import * as c from 'models/constants';
import { ErrorSummary, Button, LoadingOverlayWrapper } from 'components';
import { PortalPageSection } from 'components/PortalStructure';
import { preventRouterLeave } from 'helpers/hooks';
import { InjectedRouter } from 'react-router';
import { ManageUserWrapper } from 'containers';
import { PortalSwitchField } from 'components/FormControls';
import { IUserProfile, IUserProfileAction } from 'models/user/userprofile';
import { getUserProfile } from 'redux/modules/user/userprofile';
import { updateShopCustomer } from 'redux/modules/shop/shopcard';
import { ICustomer } from 'models/shop/customer';

interface IProps extends InjectedFormProps {
	userPreferences: IUserPreferences;
	initialValues: IUserPreferences;
	location: any;
	router: InjectedRouter;
	route: any;
	userValues: IUserProfile;

	/* form props */
	pristine: boolean;
	dirty: boolean;
	submitting: boolean;
	handleSubmit: any;
	submitFailed: boolean;
	formErrors?: any;

	/* functions props */
	getUserPreferences: () => IUserPreferencesAction;
	putUserPreferences: (userPreferences: IUserPreferences) => IUserPreferencesAction;
	getUserProfile: () => IUserProfileAction;
	t?: (key: string) => string;
}

@preventRouterLeave()
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class NotificationSettingsForm extends React.Component<IProps, {}> {
	constructor(props) {
		super(props);

		this.onSubmit = this.onSubmit.bind(this);
		this.cancelClick = this.cancelClick.bind(this);
	}

	public componentDidMount() {
		this.props.getUserProfile();
		this.props.getUserPreferences();
	}

	private onSubmit(form: IUserPreferences) {
		this.props.putUserPreferences(form);
	}

	private cancelClick() {
		browserHistory.push('/');
	}

	private mapErrorKeyToMessage(key: string) {
		switch (key) {
			default:
				return key;
		}
	}

	/** --------------RENDER ----------------------- */
	public render() {
		const { pristine, submitting, handleSubmit, t, formErrors, submitFailed, location, userValues, userPreferences } =
			this.props;
		const { error, message } = this.props.userPreferences;

		const errorSummaryProps = {
			formErrors,
			submitFailed,
			error,
			message,
			location,
			mapErrorKeyToMessage: this.mapErrorKeyToMessage,
		};

		const hasShop = Boolean(userPreferences?.userShops?.length);

		return (
			<ManageUserWrapper user={userValues}>
				<br />
				<div className="userPreferencesForm">
					<LoadingOverlayWrapper
						active={this.props.userPreferences.isFetching}
						spinner={true}
						text={t('BSPortal_Common_Loading')}
						background="rgba(0, 0, 0, 0.1)"
					>
						<form onSubmit={handleSubmit(this.onSubmit)}>
							<div>
								<ErrorSummary {...errorSummaryProps} />
							</div>
							<Field name="id" component="input" type="hidden" />
							<PortalPageSection title={t('User_NotificationSettings_Title')} variant="dark">
								{hasShop ? (
									<Field
										name="notificationOrderPendingEnabled"
										component={PortalSwitchField}
										type="checkbox"
										label={t('User_NotificationSettings_Label_ItemIsSold')}
									/>
								) : null}

								{hasShop ? (
									<Field
										name="notificationWishlistEnabled"
										component={PortalSwitchField}
										type="checkbox"
										label={t('User_NotificationSettings_Label_AddProductToWishlist')}
									/>
								) : null}
								{hasShop ? (
									<Field
										name="notificationFollowsEnabled"
										component={PortalSwitchField}
										type="checkbox"
										label={t('User_NotificationSettings_Label_FollowShop')}
									/>
								) : null}
								<Field
									name="notificationWishlistOnStockEnabled"
									component={PortalSwitchField}
									type="checkbox"
									label={t('User_NotificationSettings_Label_WishlistOnStock')}
								/>
								{hasShop ? (
									<Field
										name="notificationShopCommentEnabled"
										component={PortalSwitchField}
										type="checkbox"
										label={t('User_NotificationSettings_Label_AddReview')}
									/>
								) : null}

								<Field
									name="notificationOrderShippedEnabled"
									component={PortalSwitchField}
									type="checkbox"
									label={t('User_NotificationSettings_Label_OrderShipped')}
								/>
								<Field
									name="notificationFollowingBirthdayEnabled"
									component={PortalSwitchField}
									type="checkbox"
									label={t('User_NotificationSettings_Label_FollowingBirthday')}
								/>
								<Field
									name="notificationAppointmentReminderEnabled"
									component={PortalSwitchField}
									type="checkbox"
									label={t('User_NotificationSettings_Label_AppointmentReminder')}
								/>

								<Field
									name="isSMSNotificationEnabled"
									component={PortalSwitchField}
									type="checkbox"
									label={t('SMSNotificationPicker_Label')}
								/>
								<Button type="submit" disabled={pristine || submitting}>
									{t('BSPortal_Common_Save')}
								</Button>
							</PortalPageSection>
						</form>
					</LoadingOverlayWrapper>
				</div>
			</ManageUserWrapper>
		);
	}
}

let NotificationSettings = reduxForm({
	form: c.FORM_NAME_NOTIFICATION_SETTINGS,
	enableReinitialize: true,
})(NotificationSettingsForm);

NotificationSettings = connect(
	(state: IStore) => ({
		userValues: state.userprofile.user,
		initialValues: state.userPreferences,
		userPreferences: state.userPreferences,
		languageDomainValues: state.domainValues.languages,
		formErrors: getFormSyncErrors(c.FORM_NAME_NOTIFICATION_SETTINGS)(state),
	}),

	(dispatch) => ({
		updateShopCustomer: (newData: Partial<ICustomer>) => dispatch(updateShopCustomer(newData)),
		putUserPreferences: (form: IUserPreferences) => dispatch(putUserPreferences(form)),
		getUserPreferences: () => dispatch(getUserPreferences()),
		getUserProfile: () => dispatch(getUserProfile()),
	}),
)(NotificationSettings);

export { NotificationSettings };
